import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import { useModal } from '../../../hooks/useModal';

type Props = {
  className?: string;
  targetArea: string;
  targetName?: string;
  disabled?: boolean;
  onApplyTemplate?: (value: string) => void;
};

export const Component: FunctionComponent<Props> = ({
  className,
  targetArea,
  targetName,
  disabled,
  onApplyTemplate,
}) => {
  const { isOpen: isModalOpen, open: handleModalOpen, close: handleModalClose } = useModal(false, {
    lockBody: true,
    onClose: () => {
      if (window.location.pathname.includes('/entry_event_contents/')) {
        document.body.style.overflow = 'hidden';
      }
    }
  });

  return (
    <Presentation
      className={className}
      handleModalOpen={handleModalOpen}
      handleModalClose={handleModalClose}
      isModalOpen={isModalOpen}
      targetArea={targetArea}
      targetName={targetName || ''}
      disabled={disabled ?? false}
      onApplyTemplate={onApplyTemplate}
    />
  );
};
